// Central timezone helpers. The app operates in South Africa Standard Time
// (SAST, UTC+2). Timestamps arrive from the API as UTC ISO strings; everything
// shown to users is rendered in SAST.
export const SAST_TZ = 'Africa/Johannesburg';

// Format a date (day/month[/year]) in SAST. Returns '' on invalid input.
export const fmtDateSAST = (iso, opts = {}) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-ZA', { timeZone: SAST_TZ, ...opts });
  } catch {
    return '';
  }
};

// Format a full date + time in SAST. Returns '' on invalid input.
export const fmtDateTimeSAST = (iso, opts = {}) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleString('en-ZA', { timeZone: SAST_TZ, ...opts });
  } catch {
    return '';
  }
};

// Convert a stored UTC ISO instant to the SAST calendar date (YYYY-MM-DD),
// for pre-filling <input type="date"> pickers. en-CA yields YYYY-MM-DD.
export const toSASTDateInput = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-CA', { timeZone: SAST_TZ });
  } catch {
    return '';
  }
};
